import { GenericLookupType } from 'src/core/decorators/generic-lookup/generic-lookup-type.decorator';
import { GenericLookup } from 'src/core/decorators/generic-lookup/generic-lookup.decorator';

@GenericLookupType({
    code: 'Conversation.TranslationStatus',
})
export class ConversationTranslationStatus {
    @GenericLookup({
        code: 'Conversation.TranslationStatus.NotTranslated',
    })
    static notTranslated: number;

    @GenericLookup({
        code: 'Conversation.TranslationStatus.Translating',
    })
    static translating: number;

    @GenericLookup({
        code: 'Conversation.TranslationStatus.NotRequired',
    })
    static notRequired: number;

    @GenericLookup({
        code: 'Conversation.TranslationStatus.Skipped',
    })
    static skipped: number;

    @GenericLookup({
        code: 'Conversation.TranslationStatus.Translated',
    })
    static translated: number;

    @GenericLookup({
        code: 'Conversation.TranslationStatus.Failed',
    })
    static failed: number;
}